export default {
    pdf: 1
};